var AbstractWS = require("./AbstractWS");

function StartServiceTransactionWS(parent) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.method('POST');
  self.name = 'StartServiceTransactionWS';


	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/serviceTransaction/start';
  });


  return self;
};

StartServiceTransactionWS.prototype = AbstractWS.prototype;
StartServiceTransactionWS.prototype.constructor = StartServiceTransactionWS;

module.exports = StartServiceTransactionWS
